import { render, staticRenderFns } from "./lactatingCows.vue?vue&type=template&id=e6b377f2&scoped=true&"
import script from "./lactatingCows.vue?vue&type=script&lang=js&"
export * from "./lactatingCows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b377f2",
  null
  
)

export default component.exports